// @ts-ignore
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import RelationGraph, {RelationGraphInstance} from 'relation-graph/react';
import BsyAlertListDetail from "../BsyAlertListDetail";
import RelationshipDetail from "./RelationshipDetail.jsx";
import SimpleLine from "./SimpleLine.jsx"

let nodeDataNodesMap = {};

let nodeDataLinesMap = {};

let rootId = "";

const getFormTypeText = (t) =>{
  switch (t){
    case "extend":
      return React.language("referenceExtend.label");
    case "form":
      return React.language("form");
    case "dash":
      return React.language("dash.report");
    case "etl":
    case "etl_table":
      return React.language("editer_view");
    case "scenes":
      return React.language("scenes.report");
    case "aggregate_table":
      return React.language("app.category.aggregate");
  }
}

const getFormTypeIcon = (t) =>{
  switch (t){
    case "extend":
      return "icon-bsy-extend";
    case "form":
      return "icon-bsy-form-0";
    case "dash":
      return "icon-bsy-new-report";
    case "etl":
    case "etl_table":
      return "icon-bby-iconzuzhigoujia";
    case "scenes":
      return "icon-bsy-new-report";
    case "aggregate_table":
      return "icon-app-aggregate";
  }
}

const NodeSlot = ({node}) => {
  return <div id={node.id} className={`rel-node-item ${nodeDataNodesMap[node.id]?.formType}`} title={node.text}
  // onMouseEnter={(event) => {
  //   window.FX.UI.showPopover({
  //     position: "bottomLeft",
  //     anchor: window.$(event.target),
  //     content: window.$("<div class='rel-node-item-tip' />").append(window.$("<span class='formType' />").addClass(nodeDataNodesMap[node.id]?.formType).text(getFormTypeText(nodeDataNodesMap[node.id]?.formType))).append(window.$("<span class='formTypeText' />").text(node.text)),
  //   })
  // }} onMouseLeave={() => {
  //   window.FX.UI.closePopover()
  // }}
  >
    <div className="nodeNameContent">
      <i className={`formTypeIcon ${getFormTypeIcon(nodeDataNodesMap[node.id]?.formType)} ${nodeDataNodesMap[node.id]?.formType}`}></i>
      <span className={"nodeName"}>{node.text}</span>
    </div>
    {!!nodeDataNodesMap[node.id]?.url && <a href={nodeDataNodesMap[node.id]?.url} target={"_blank"} style={{fontSize: '16px', marginLeft: '6px'}}><i
      className={'icon-bsy-reportmenu-1'}></i></a>}
  </div>
};

const LineSlot = ({line, link, relationGraph}) => {
  return <SimpleLine
    line={line}
    link={link}
    relationGraph={relationGraph}
  />
};

const getTypeColor = (t) =>{
  switch (t){
    case "extend":
      return "8F23F6";
    case "form":
      return "0265FF";
    case "dash":
      return "4ACC8C";
    case "etl":
    case "etl_table":
      return "2BC2E1";
    case "scenes":
      return "4ACC8C";
    case "aggregate_table":
      return "FF9921";
  }
}

const getDataMap = (v, byReferenceValue) =>{
  const byNode = v.byFormInfo;
  const node = v.formInfo;
  let byNodeId = "";
  let byNodeName = "";
  let nodeId = "";
  let nodeName = "";
  let url = "";
  let byUrl = "";
  if(byNode.formType === "extend"){
    byNodeId = byNode.id;
    byNodeName = byNode.name;
  }else{
    byNodeId = (byNode.formId && byNode.appId) ? (byNode.formId + "@" + byNode.appId) : "";
    byNodeName = byNode.formName;
    byUrl = `/dashboard/app/${byNode.appId}/${byNode.formType}/${byNode.formId}/edit#/`;
  }
  if(node.formType === "extend"){
    nodeId = node.id;
    nodeName = node.name;
  }else{
    nodeId = (node.formId && node.appId) ? (node.formId + "@" + node.appId) : "";
    nodeName = node.formName;
    url = `/dashboard/app/${node.appId}/${node.formType}/${node.formId}/edit#/`;
  }



  if(byReferenceValue === "1"){
    rootId = nodeId;
  }else{
    rootId = byNodeId;
  }

  nodeDataNodesMap[byNodeId] = {
    id: byNodeId, styleClass: byReferenceValue === "1" ? "nodeStyle2" : "", text: byNodeName, url: byUrl, formType: byNode.formType, myicon: 'icon-edit', opacity: 1, nodeShape: 1, width: 200, height: 36, borderColor: `#${getTypeColor(byNode.formType)}`, backgroundColor: "#ffffff", data: [byNode]
  }

  nodeDataNodesMap[nodeId] = {
    id: nodeId, styleClass: byReferenceValue !== "1" ? "nodeStyle2" : "", text: nodeName, url: url, formType: node.formType, myicon: 'icon-edit', opacity: 1, nodeShape: 1, width: 200, height: 36, borderColor: `#${getTypeColor(node.formType)}`, backgroundColor: "#ffffff", data: [node]
  }

  nodeDataLinesMap[byNodeId + "&&" + nodeId] ? nodeDataLinesMap[byNodeId + "&&" + nodeId].data.push(v) : (nodeDataLinesMap[byNodeId + "&&" + nodeId] = {
    styleClass: "lineStyle2", to: byNodeId, from: nodeId, data:[v], opacity: 1, lineWidth: 2, color: "#0265ff", fontColor: "#FFFFFF", useTextPath: false,
    // showStartArrow: byReferenceValue !== "1", showEndArrow: byReferenceValue === "1"
  })
}

const setData = (data, cd, byReferenceValue) => {
  nodeDataNodesMap = {};
  nodeDataLinesMap = {};
  rootId = "";
  data.map((item, key)=>{
    getDataMap(item, byReferenceValue);
  })


  const nodeData = {
    rootId: rootId,
    nodes: [],
    lines: []
  };

  for (let key in nodeDataNodesMap) {
    nodeData.nodes.push(nodeDataNodesMap[key]);
  }
  for (let key in nodeDataLinesMap) {
    nodeDataLinesMap[key].text = nodeDataLinesMap[key].data.length;
    nodeData.lines.push(nodeDataLinesMap[key]);
  }

  return nodeData
}

const SimpleGraph = forwardRef((props, ref) => {
  const byReferenceValue = props.byReferenceValue;
  const graphRef = useRef();
  const staticJsonData = setData(props.viewData, null, byReferenceValue);

  useEffect(() => {
    showGraph();

  }, [staticJsonData]);

  const someFunction = (v) => {
    // showGraph();
    // graphInstance.refresh();
    console.log('在 YourComponent 中调用的函数，访问 someValue:', v);
    // 其他逻辑...
  };

  const showGraph = async () => {
    // The node and line in the above data can refer to the options in "Node" and "Link & Line" for configuration.
    // Node: https://www.relation-graph.com/#/docs/node
    // Link & Line: https://www.relation-graph.com/#/docs/link
    await graphRef.current?.setJsonData(staticJsonData, (graphInstance) => {
      // Do something when graph ready
    });
    // The graphRef.current.setJsonData(jsonData, callback) method is a convenient method that is equivalent to the following code:
     const graphInstance = graphRef.current?.getInstance();
    //  graphInstance.addNodes(jsonData.nodes);
    //  graphInstance.addLines(jsonData.lines);
    //  graphInstance.rootNode = graphInstance.getNodeById(jsonData.rootId);
    //  await graphInstance.doLayout(); // Layout using the layouter set in graphOptions
    //  await graphInstance.moveToCenter(); // Find the center based on node distribution and center the view
    //  await graphInstance.zoomToFit(); // Zoom to fit, so that all nodes can be displayed in the visible area
    await graphInstance.setZoom("100");
  }

  const options = {
    debug: false,
    disableDragNode: true,
    allowShowMiniToolBar: true,
    allowSwitchLineShape: false,
    backgroundColor: "#F5F7FA",
    allowSwitchJunctionPoint: false,
    allowAutoLayoutIfSupport: false,
    allowShowRefreshButton: false,
    allowShowDownloadButton: false,
    defaultNodeBorderWidth: 1,
    defaultNodeShape: 1,
    defaultLineShape: 6,
    checkedNodeId: rootId,
    zoomToFitWhenRefresh: false,
    defaultLineMarker: {
      markerWidth: 15,
      markerHeight: 15,
      refX: byReferenceValue === "1" ? "3" : "3",
      refY: byReferenceValue === "1" ? "3" : "3",
      data: "M 0 0, V 6, L 6 3, Z"
    },
    // disableNodeClickEffect: false,
    // disableLineClickEffect: true,
    // checkedLineColor: "#0265ff",
    // defaultFocusRootNode: "#0265ff",
    layout: {
      layoutName: 'tree',
      // from: 'left',
      from: byReferenceValue === "1" ? 'left' : 'right',
      'min_per_width': 270, // 根据节点的宽度设置，这个是让图谱看起来偏亮的关键
      'min_per_height': 200,
    },
    defaultPloyLineRadius: 10,
    disableLineClickEffect: true,
    defaultJunctionPoint: 'lr',
    defaultExpandHolderPosition: 'hide'
  };

  const handleNodeClick = (r, a) => {
    // 获取关系图实例，可能是通过某个变量 d.value 存储的

    const graphInstance = graphRef.current?.getInstance();
    // 如果获取到关系图实例，处理节点的点击事件
    if (graphInstance) {
      // 获取所有链接，若不存在则设为空数组
      const links = graphRef.current?.getLinks() || [];
      const nodes = graphRef.current?.getNodes() || [];
      nodes.forEach(node => {
        node.data.orignColor = undefined;
        node.data.orignFontColor = undefined;
        node.data.orignLineWidth = undefined;
        node.color = undefined;
        node.fontColor = undefined;
        node.lineWidth = undefined;
        node.opacity = 0.6;
        node.styleClass = undefined;
      });
      // 重置所有关系的颜色、字体颜色和线宽为原始值
      links.forEach(link => {
        link.relations.forEach(relation => {
          relation.data.orignColor = undefined;
          relation.data.orignFontColor = undefined;
          relation.data.orignLineWidth = undefined;
          relation.color = undefined;
          relation.fontColor = "#ffffff";
          relation.lineWidth = 1;
          relation.opacity = 0.6;
          relation.styleClass = undefined;
        });
      });

      // 获取与点击的节点相关的链接
      const relatedLinks = links.filter(link => link.fromNode === r || link.toNode === r);
      const hasId = r.targetFrom.map(tf => tf.id ).concat(r.targetTo.map(tf => tf.id )).concat([r.id]);
      // 修改相关链接的颜色、字体颜色和线宽
      relatedLinks.forEach(link => {
        link.relations.forEach(relation => {
          relation.data.orignColor = relation.color;
          relation.data.orignFontColor = relation.fontColor;
          relation.data.orignLineWidth = relation.lineWidth || 1;
          relation.fontColor = "#ffffff";
          relation.color = "#0265ff";
          relation.lineWidth = 2;
          relation.opacity = 1;
          relation.styleClass = "lineStyle2";
        });
      });

      nodes.forEach(node => {
        if(hasId.indexOf(node.id) > -1){
          if(r.id !== node.id){
            node.styleClass = "nodeStyle2";
            node.opacity = 1;
          }else{
            node.styleClass = "nodeStyle3";
            node.opacity = 1;
          }
        }
      });

      // 更新关系图数据

      graphInstance.dataUpdated();
      // graphRef.current?.focusNodeById(r.id);
    }
  };
  const onNodeClick = (node, _e) => {
    handleNodeClick(node, _e)
    // graphRef.current?.updateView();
    return true;
  };
  const onLineClick = (line, _link, _e) => {
    BsyAlertListDetail({
      type: "custom",
      width: 400,
      createContent:(e)=>{
        const { data } = nodeDataLinesMap[line.to + "&&" + line.from];
        return <RelationshipDetail newProps={e} data={data} />
      }
    })
    return true;
  };
  const onCanvasClick = ($event) => {
    if($event.target.classList.value.indexOf("rel-map-ready") < 0){
      return
    }
    const graphInstance = graphRef.current?.getInstance();
    // 如果获取到关系图实例，处理节点的点击事件

    if (graphInstance) {
      // 获取所有链接，若不存在则设为空数组
      const links = graphRef.current?.getLinks() || [];
      const nodes = graphRef.current?.getNodes() || [];
      nodes.forEach(node => {
        node.data.orignColor = undefined;
        node.data.orignFontColor = undefined;
        node.data.orignLineWidth = undefined;
        node.color = undefined;
        node.boxShadow = undefined;
        node.fontColor = undefined;
        node.lineWidth = undefined;
        node.opacity = 1;
        node.styleClass = undefined;
      });
      // 重置所有关系的颜色、字体颜色和线宽为原始值
      links.forEach(link => {
        link.relations.forEach(relation => {
          relation.data.orignColor = undefined;
          relation.data.orignFontColor = undefined;
          relation.data.orignLineWidth = undefined;
          relation.color = undefined;
          relation.styleClass = undefined;
          relation.fontColor = "#ffffff";
          relation.lineWidth = 2;
          relation.opacity = 1;
        });
      });

      // 更新关系图数据

      graphInstance.clearChecked();
      graphInstance.dataUpdated();
      // graphRef.current?.updateView();
    }
  };
  return <div style={{ height: "100%", width: "100%" }}>
    <div style={{ height: "100%", width: "100%" }}>
      <RelationGraph
        ref={graphRef}
        options={options}
        onCanvasClick={onCanvasClick}
        nodeSlot={NodeSlot}
        lineSlot={LineSlot}
        onNodeClick={onNodeClick}
        onLineClick={onLineClick}
      >
      </RelationGraph>
    </div>
  </div>;
});
export default SimpleGraph;